import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
  const [authState, setAuthState] = useState('checking');

  useEffect(() => {
    const checkAuth = async () => {
      const token = sessionStorage.getItem('adminToken');
      if (!token) {
        setAuthState('unauthenticated');
        return;
      }
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
        const res = await fetch(`${BACKEND_URL}/api/admin/me`, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        setAuthState(res.ok ? 'authenticated' : 'unauthenticated');
        if (!res.ok) sessionStorage.removeItem('adminToken');
      } catch {
        setAuthState('unauthenticated');
      }
    };
    checkAuth();
  }, []);

  if (authState === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600" />
      </div>
    );
  }

  if (authState === 'unauthenticated') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};
